<template lang="pug">
v-container
	v-data-table(:headers="headers" :items="surveys" hide-default-footer no-results-text="查無資料" :search="search")
		template(v-slot:body="{items}")
			tbody
				tr(v-for="item,i in items" :key="i")
					td {{item.date}}
					td {{item.time}}
					td {{item.createAt}}
					td {{item.identity}}
					td {{item.route}}
					td
						v-layout
							v-btn(fab small @click="browse=item; dialog=true")
								v-icon mdi-history
							v-btn(fab small @click="removeSurvey(item.feedbackId)")
								v-icon mdi-delete
	v-layout.psf
		v-text-field(label="搜尋" v-model="search"
			:style="{width: toggle?'200px':0, transition: '0.5s'}")
		v-btn(fab @click="toggle=!toggle")
			v-icon mdi-file-find
	v-dialog(v-model="dialog" width="500").overflow-y
		v-card.white
			v-card-title.blue.white--text {{browse.date}} {{browse.time}} - {{browse.identity}} {{browse.route}}
			table.table
				tr.blue.lighten-2.white--text
					td 問項
					td 題目
					td 類型
					td 選擇
				tr(v-for="item in browse.items" :key="item.question_tag")
					td {{item.question_tag}}
					td {{item.question_name}}
					td {{item.question_type}}
					td {{item.answer}}
</template>

<script>
import { db, shot2docs } from '../main';
import axios from 'axios';

export default {
	name: 'record',
	data() {
		return {
			headers: [
				{ text: '日期', value: 'date' },
				{ text: '時間', value: 'time' },
				{ text: '回填', value: 'createAt' },
				{ text: '身分', value: 'identity' },
				{ text: '路線', value: 'route' },
				{ text: '操作' },
			],
			browse: {},
			surveys: [],
			search: '',
			toggle: false,
			dialog: false,
		};
	},
	methods: {
		async removeSurvey(feedbackId) {
			try {
				const response = await axios.post(`/api/Questionnaire/DeleteAnswer?id=${feedbackId}`);
				if (response.data.status) {
					this.surveys = this.surveys.filter(x => x.feedbackId !== feedbackId);
					alert('刪除成功');
				} else {
					alert(response.data.message || '刪除失敗');
				}
			} catch (error) {
				console.error('刪除問卷錯誤:', error);
				alert('刪除失敗');
			}
		},
		async loadSurveys() {
			try {
				const response = await axios.get('/api/Questionnaire/QuestionnaireAnswerList?own=true');
				if (response.data.status && response.data.result) {
					this.surveys = response.data.result.map(item => ({
						feedbackId: item.feedback_id,
						date: item.fill_date ? item.fill_date.split('T')[0] : '',
						time: item.fill_time || '',
						createAt: item.created_at ? item.created_at.split('T')[0] : '',
						identity: item.identity_name || '',
						route: item.route_name || '',
						items: item.answers || []
					}));
				}
			} catch (error) {
				console.error('載入問卷記錄錯誤:', error);
			}
		}
	},
	mounted() {
		this.loadSurveys();
	},
};
</script>
